const BRAZILIAN_STRIPE_ACCOUNTS = ['Famio - BR 2']

export const isBrazilianStripeAccount = (accountName: string) =>
  BRAZILIAN_STRIPE_ACCOUNTS.includes(accountName)
